import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { routes } from './routes';
import { AuthContext } from './context/authContext';
import Login from './pages/Login';
import Maintenance from './pages/Maintenance';

export default function AppRoutes() {
  const { currentUser, loading, isLoggedIn } = useContext(AuthContext);
  const isUnderMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  // No loading splash. Nearly every route in routes.js wraps its own
  // <AuthContextProvider>, so each navigation remounts it and re-runs autoLogin —
  // which meant the animated logo flashed on every single click, not just on a
  // cold refresh. Render nothing and let the page appear when it is ready.
  if (loading) {
    return null;
  }

  if (isUnderMaintenance) {
    return <Maintenance />;
  }

  return (
    <Routes>
      {routes.map((item) => (
      <Route
      key={item.path}
      exact
      path={item.path}
      element={item.isProtected && !isLoggedIn ? <Login /> : item.element}
    />
    
      ))}
    </Routes>
  );
}
